<div class="profile-news pb-4">
    <div class="profile-news__header mb-3">
        <button class="button-2 mr-2" *ngIf="isOwner" (click)="openModalBlogForm()">
            <i class="fa-solid fa-plus"></i>
            Add News
        </button>
    </div>
    <div class="profile-news__content">
        <div class="profile-news__content__item" *ngIf="banners?.length == 0">
            <div class="profile-news__content__item__empty">
                <i class="fa-regular fa-newspaper fa-3x mb-3"></i>
                <p>No news found</p>
                <p class="text-muted">Share your latest updates and announcements here</p>
            </div>
        </div>

        <div class="profile-news__content__item">
            <div class="sg-new-grid">
                <ng-container *ngFor="let i of banners">
                    <div class="my-card">
                        <!-- <div class="heart" (click)="likeHandle(i?.id, i)" style="color: salmon !important">
                            <i class="fa-{{ hasChecked(i?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                            <span>{{ i?.bottomBannerLikes?.length }}</span>
                        </div> -->
                        <img loading="lazy" src="{{ imgUrl + (i?.image ?? '') }}"
                            [routerLink]="'/news/' + (i?.slug ?? i?.id)" alt="..."
                            (error)="commonService?.handleError?.($event)" />
                        <div class="body">
                            <div class="body--meta">
                                <span>{{ i?.category }}</span>
                                <div class="options" *ngIf="isOwner">
                                    <div class="icon" aria-hidden="true" id="list-new" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-ellipsis-v"></i>
                                    </div>
                                    <div class="dropdown-menu" aria-labelledby="list-new">
                                        <a class="dropdown-item" (click)="openModalBlogForm(i)">Edit</a>
                                        <a class="dropdown-item" (click)="deleteBlog(i?.id)">Delete</a>
                                    </div>
                                </div>
                            </div>
                            <p class="body--title" [routerLink]="'/news/' + (i?.slug ?? i?.id)">
                                {{ i?.title }}
                            </p>
                            <div class="body--details">
                                <div class="item">
                                    <i class="fa fa-user"></i>
                                    <span>
                                        {{ i?.author | truncate : 20 }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<app-form-new #formNew (initData)="getNewsList()"></app-form-new>